#@import I18n
#@import $
#@import $.PlaceholderField
#@import Booking.Presenters.Phone
#@import Booking.Views.Base
#@export Booking.Views.Phone

class Booking.Views.Phone extends Booking.Views.Base

  presenter: Booking.Presenters.Phone

  templateName: 'phone'

  maxDigitCount: 10

  events:
    'keypress input': 'formatPhoneNumber'
    'paste input': 'dismissPasteEvent'
    'keyup input': 'triggerEvents'
    'change input': 'clearable'
    'keydown input': 'clearable'
    'click .clear': 'clear'

  constructor: ->
    Booking.Views.Base.apply this, arguments

    @listenTo @model, "phoneNumber:preset", -> @render() if @canRender()

  canRender: ->
    @model.requirePhone()

  render: ->
    Booking.Views.Base::render.apply this, arguments
    @$input = @$el.find('input')
    @input = @$input.get(0)
    @$input.PlaceholderField?()
    @clearable()
    this

  isntDigitOrControlKey: (charCode) ->
    charCode > 31 and (charCode < 48 or charCode > 57)

  # borrowed and adapted from https://github.com/stripe/jquery.payment/blob/master/src/jquery.payment.coffee#L128-L160
  formatPhoneNumber: (e) ->
    # Let control keys go through. But prevent any other keystoke.
    return false if @isntDigitOrControlKey(e.which)

    # Only format if input is a number
    digit = String.fromCharCode(e.which)

    return true unless /^\d+$/.test(digit)

    value   = @input.value
    length  = (value.replace(/\D/g, '') + digit).length

    if length > @maxDigitCount
      e.preventDefault()
      @input.value = value
      return

    # Return if focus isn't at the end of the text
    return if @$input.prop('selectionStart')? and @$input.prop('selectionStart') isnt value.length

    re =  /^(\d{3}|\d{3}\-\d{3})$/

    if re.test(value)
      e.preventDefault()
      @input.value = "#{value}-#{digit}"

    else if re.test(value + digit)
      e.preventDefault()
      @input.value = "#{value}#{digit}-"

  isValidLength: (value = '') ->
    value.length is @options.customerPhoneMaxLength

  triggerEvents: ->
    value = @$input.val()
    if @isValidLength(value)
      event = 'complete'
      @model.setPhoneNumber value if @model.setPhoneNumber
      @hideInvalid()
    else
      event = 'incomplete'
      @model.setPhoneNumber undefined if @model.setPhoneNumber

    @trigger event, value

  dismissPasteEvent: ->
    false

  focus: ->
    @input.focus()

  clearable: ->
    method = if @input?.value?.length then 'addClass' else 'removeClass'
    @$el[method]('clearable')

  clear: ->
    @input.value = ''
    @triggerEvents()
    @clearable()
    @focus()

  shouldShowInvalid: ->
    not @isValidLength(@model.getPhoneNumber())

  showInvalid: ->
    @$('.wrapper').addClass('invalid')

  hideInvalid: ->
    @$('.wrapper').removeClass('invalid')
